// extracted by mini-css-extract-plugin
export var productImage = "_ml-0";